import { Pipe, PipeTransform } from '@angular/core';
import { IRootState } from '@bca-store/store.reducers';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, withLatestFrom } from 'rxjs/operators';
import { IProduct } from '@bca-shared/models/product';
import { Route } from '@bca-shared/models/_enums';

@Pipe({ name: 'productSelected', pure: false })
export class ProductSelectedPipe implements PipeTransform {
  constructor(private _store$: Store<IRootState>) {}

  transform(product: IProduct): Observable<boolean> {
    return this._store$.pipe(
      select(({ compose }) => compose.selectedProduct),
      take(1),
      withLatestFrom(
        this._store$.pipe(select(({ userData }) => userData.selectedProduct)),
        this._store$.pipe(select(({ app }) => app.currentRoute))
      ),
      map(([selectedComposeProduct, selectedUserDataProduct, route]) => {
        return route > Route.COMPOSE
          ? [selectedComposeProduct, selectedUserDataProduct]
          : [selectedComposeProduct];
      }),
      map((products: IProduct[]) => products.filter(prod => prod != null)),
      map((products: IProduct[]) =>
        products.some(prod => prod.id === product.id)
      )
    );
  }
}
